import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {LoanApplication} from '../schema/loan-appication/loan-application';
import {Borrower} from '../schema/loan-appication/borrower';
import {LoanApplicationConstant} from './loan-application-constant';
import {CommonUtilService} from "@services/common-util.service";
import {catchError} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
const API_URL = environment.POS_BFF_URL;
import { map } from "rxjs/operators";
import {HousingExpenses} from "@data/schema/loan-appication/housing-expenses";
import {CurrentIncomeItem} from "@data/schema/loan-appication/current-income-item";
import {Declaration} from "@data/schema/loan-appication/declaration";
import {DemographicGovtQuestions} from "@data/schema/loan-appication/demographic-govt-questions";
import {Search} from "@data/schema/loan-appication/search";
import {LoanDocument} from "@data/schema/loan-appication/loan-document";
import {LoanDocumentType} from "@data/schema/account/document-type";
import {ExternalServiceRequest} from "@data/schema/loan-appication/external-service-request";
import {ExternalServiceResponse} from "@data/schema/loan-appication/external-service-response";
import {AppUser} from "@data/schema/account/app-user";
import {LoanAudit} from "@data/schema/loan-appication/loan-audit";
import {BorrowerAction} from "@data/schema/loan-appication/borrower-action";
@Injectable({
  providedIn: 'root'
})
export class LoanApplicationService {
  constructor(private http: HttpClient, private loanApplicationConstants: LoanApplicationConstant
              , private commonUtilService: CommonUtilService) {
  }
  headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  requestOptions = {
    headers: new HttpHeaders(this.headerDict)
  };

  getLoanApplication(): Observable<LoanApplication[]> {
    return of(<LoanApplication[]>JSON.parse(localStorage.getItem('loanApp')));
  }

  updateLoanApplication(
    loanApplication: LoanApplication,
  ): Observable<LoanApplication> {
    return this.saveLoanApplication(loanApplication);
  }
  createLoanApplication(
    loanApplication: LoanApplication,
  ): Observable<LoanApplication> {
    return this.createNewLoanApplication(loanApplication);
  }
  createLoanApplicationByXML(
    formData: FormData,
  ): Observable<LoanApplication> {
     return this.uploadLoanApplication(formData);

  }
   setDelay(i) {

  }
  private getBorrowers(response: any): Borrower[] {
    return (<Borrower[]>response).map(
      borrower =>
        this.getBorrower(borrower)
    );
  }

  getBorrower(borrower): Borrower{
     return borrower;
  }

  getLoanPipelineByUserId(userId: string,clientId: string) : Observable<LoanApplication[]>{
    return this.getLoanPipeline(userId,clientId);
  }

  updateItemInList( loanApplication: LoanApplication): Observable<LoanApplication>{
    let loanAppList = [];
      this.saveLoanApplication(loanApplication).subscribe(loanApp =>{

    });

    return of(loanApplication);
  }
  getLoanAppFromList(id: string): Observable<LoanApplication> {
      return this.getLoanApplicationByLoanId(id);
  }


  errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
      console.log(error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log(error);
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError("Something bad happened; please try again later.");
  }
  public uploadLoanApplication(data: FormData): Observable<any> {

    return this.http
      .post(
        API_URL + "/api/v1/oauth/create-loan-application/upload-file",
        data
      )
      .pipe(
        map(response => {
            return response;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public saveLoanApplication(data: LoanApplication): Observable<LoanApplication> {
     return this.http
      .post(
        API_URL + "/api/v1/oauth/save-loan-application",
        data )
      .pipe(
        map(response => {
          return response as LoanApplication;
        })
      )
      .pipe(catchError(this.errorHandler))


  }
  public createNewLoanApplication(data: LoanApplication): Observable<LoanApplication> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/create-new-loan-application",
        data )
      .pipe(
        map(response => {
          return response as LoanApplication;
        })
      )
      .pipe(catchError(this.errorHandler))


  }
  public inviteBorrower(data: LoanApplication): Observable<AppUser> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/invite-borrowers",
        data )
      .pipe(
        map(response => {
          return response as AppUser;
        })
      )
      .pipe(catchError(this.errorHandler))


  }
  public createBlankLoanApplication(createNewLoanType : string,clientId: string): Observable<LoanApplication> {
     return this.http
      .get(
        API_URL + "/api/v1/oauth/create-blank-application?createNewLoanType="+createNewLoanType+"&clientId="+clientId)
      .pipe(
        map(response => {
          return response as LoanApplication;
        })
      )
      .pipe(catchError(this.errorHandler));
  }


  public getLoanApplicationByLoanId(loanId: string): Observable<LoanApplication> {
    return this.http
      .get(
        API_URL + "/api/v1/oauth/get-loan-application-by-loanid?loanId="+loanId,
         )
      .pipe(
        map(response => {
          return response as LoanApplication;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public getLoanPipeline(userId : string, clientId : string): Observable<LoanApplication[]> {
    return this.http
      .get(API_URL +'/api/v1/oauth/get-loan-application-by-userid?userId=' + userId+'&clientId='+clientId
      )
      .pipe(
        map(response => {
          return response as LoanApplication[];
        })
      ).pipe(catchError(this.errorHandler));
  }
  public getBorrowerPipeline(userId : string): Observable<LoanApplication[]> {
    return this.http
      .get(API_URL +'/api/v1/oauth/borrower-pipeline?userId=' + userId
      )
      .pipe(
        map(response => {
          return response as LoanApplication[];
        })
      ).pipe(catchError(this.errorHandler));
  }


  public delateLoanApplicationById(loanId : string) {
     return this.http
      .get(API_URL +'/api/v1/oauth/delete-by-loanid?loanId=' + loanId
      )
      .pipe().pipe(catchError(this.errorHandler));
  }

  public getSearch(searchModel : Search): Observable<LoanApplication[]> {
    return this.http
      .post(API_URL +'/api/v1/oauth/get-search' , searchModel )
      .pipe(
        map(response => {
          return response as LoanApplication[];
        })
      ).pipe(catchError(this.errorHandler));
  }


  public downloanLoanApplication(loanId: string): Observable<Blob> {
    let params = new HttpParams();
    params = params.append("loanId", loanId)
    return this.http
      .get(API_URL + "/api/v1/oauth/download-urla-xml", {
        params: params,
        responseType: "blob"
      })
      .pipe();
  }
  public uploadLoanDocument(data: FormData): Observable<LoanDocument> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/loan-document-upload",
        data
      )
      .pipe(
        map(response => {
          return response as LoanDocument;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public saveLoanDocument(data: FormData): Observable<LoanDocument> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/save-loan-document",
        data
      )
      .pipe(
        map(response => {
          return response as LoanDocument;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public getLoanDocumentTypeByClientId(clientId : string): Observable<LoanDocumentType[]> {
    return this.http
      .get(API_URL +'/api/v1/oauth/get-loan-document-types-by-clientid?clientId=' + clientId
      )
      .pipe(
        map(response => {
          return response as LoanDocumentType[];
        })
      ).pipe(catchError(this.errorHandler));
  }
  public getPreSignedDocument(loanDocument: LoanDocument): Observable<LoanDocument> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/get-pre-signed-doc-url",
        loanDocument
      )
      .pipe(
        map(response => {
          return response as LoanDocument;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public losServiceRequest(data: ExternalServiceRequest): Observable<ExternalServiceResponse> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/los_service_request",
        data
      )
      .pipe(
        map(response => {
          return response as ExternalServiceResponse;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public createLoanAudit(data: LoanAudit): Observable<LoanAudit> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/create-loan-audit",
        data
      )
      .pipe(
        map(response => {
          return response as LoanAudit;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public getLoanAuditByLoanIdAndClientId(loanId:string,clientId : string): Observable<LoanAudit[]> {
    return this.http
      .get(API_URL +'/api/v1/oauth/get-loan-audit-by-loanid-clientid?loanId='+loanId+'&clientId='+ clientId
      )
      .pipe(
        map(response => {
          return response as LoanAudit[];
        })
      ).pipe(catchError(this.errorHandler));
  }
  public createLoanAudits(data: LoanAudit[]): Observable<LoanAudit[]> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/create-loan-audits",
        data
      )
      .pipe(
        map(response => {
          return response as LoanAudit[];
        })
      )
      .pipe(catchError(this.errorHandler));
  }

  public createBorrowerAction(data: BorrowerAction): Observable<BorrowerAction> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/create-borrower-action",
        data
      )
      .pipe(
        map(response => {
          return response as BorrowerAction;
        })
      )
      .pipe(catchError(this.errorHandler));
  }
  public getBorrowerActionByLoanIdAndClientId(loanId:string,clientId : string): Observable<BorrowerAction[]> {
    return this.http
      .get(API_URL +'/api/v1/oauth/get-borrower-action-by-loanid-clientid?loanId='+loanId+'&clientId='+ clientId
      )
      .pipe(
        map(response => {
          return response as BorrowerAction[];
        })
      ).pipe(catchError(this.errorHandler));
  }
  public createBorrowerActions(data: BorrowerAction[]): Observable<BorrowerAction[]> {
    return this.http
      .post(
        API_URL + "/api/v1/oauth/create-borrower-actions",
        data
      )
      .pipe(
        map(response => {
          return response as BorrowerAction[];
        })
      )
      .pipe(catchError(this.errorHandler));
  }






}

export enum BUTTON_EVENTS {
  SAVE_AND_CLOSE = 'SAVE_AND_CLOSE',
  CLOSE = 'CLOSE',
  STATE_LOADED_SUCCESSFULLY ='STATE_LOADED_SUCCESSFULLY',
  TAXONOMY_LOADED_SUCCESSFULLY ='TAXONOMY_LOADED_SUCCESSFULLY',
  SAVE = 'SAVE',
  SAVE_ONLY = 'SAVE_ONLY',
  DOCUMENT_SAVE_CLOSE ='DOCUMENT_SAVE_CLOSE_SUCCESSFULLY',
  LOAN_AUDIT_SAVE = 'LOAN_AUDIT_SAVE',
  AUDIT_TAB_CLICKED = 'AUDIT_TAB_CLICKED',
  BORROWER_ACTIONS_TAB_CLICKED = 'BORROWER_ACTIONS_TAB_CLICKED',
  OVERVIEW_TAB_CLICKED = 'OVERVIEW_TAB_CLICKED',
  LOAN_APPLICATION_TAB_CLICKED = 'LOAN_APPLICATION_TAB_CLICKED',
  BORROWER_TAB_CLICKED = 'BORROWER_TAB_CLICKED',
  ASSET_AND_LIABILITIES_TAB_CLICKED = 'ASSET_AND_LIABILITIES_TAB_CLICKED',
  REO_TAB_CLICKED = 'REO_TAB_CLICKED',
  LOAN_AND_PROPERTY_TAB_CLICKED = 'LOAN_AND_PROPERTY_TAB_CLICKED',
  DECLARATION_TAB_CLICKED = 'DECLARATION_TAB_CLICKED',
  DEMOGRAPHICS_TAB_CLICKED = 'DEMOGRAPHICS_TAB_CLICKED',




}
export enum BORROWER_BUTTON_EVENTS {
  BORROWER_INFO_SAVE = 'BORROWER_INFO_SAVE',
  BORROWER_ADDRESS_SAVE = 'BORROWER_ADDRESS_SAVE',
  BORROWER_EMPLOYMENT_INCOME_SAVE = 'BORROWER_EMPLOYMENT_INCOME_SAVE',
  BORROWER_PREVIOUS_EMPLOYMENT_SAVE = 'BORROWER_PREVIOUS_EMPLOYMENT_SAVE',
  BORROWER_MILIATRY_SAVE = 'BORROWER_MILIATRY_SAVE',
  BORROWER_ASSETS_SAVE = 'BORROWER_ASSETS_SAVE',
  BORROWER_LIABILITY_SAVE = 'BORROWER_LIABILITY_SAVE',
  BORROWER_REO_SAVE = 'BORROWER_REO_SAVE',
  BORROWER_DECLARATION_SAVE = 'BORROWER_DECLARATION_SAVE',
  BORROWER_DEMOGRAPHICS_SAVE = 'BORROWER_DEMOGRAPHICS_SAVE',
  BORROWER_DECLARATION1_SAVE = 'BORROWER_DECLARATION1_SAVE',
  BORROWER_LOAN_SAVE = 'BORROWER_LOAN_SAVE',
  BORROWER_SUBJECT_PROPERTY_SAVE = 'BORROWER_SUBJECT_PROPERTY_SAVE',
  BORROWER_ADD_SAVE = 'BORROWER_ADD_SAVE',
  BORROWER_lOAN_DOCUMENT_SAVE = 'BORROWER_lOAN_DOCUMENT_SAVE',

}

